import styled from "@emotion/styled";

import { ContextMenu, MenuItem, MenuItemLabel, SkiliticsIcon } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";
import type { MultilingualizableConfigValue } from "@skilitics/nautilus-core-designer-data";

import { useMultilingualOptIn } from "./useMultillingualOptIn";

type Props = {
  nodeId: number;
  property: string;
  initialValue: MultilingualizableConfigValue;
};

export const MultilingualOverrideControls = ({ nodeId, property, initialValue }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);
  const [multilingualOptedIn, setMultilingualOptedIn] = useMultilingualOptIn(nodeId, property);

  return (
    <ContextMenu
      IconComponent={<StyledIcon icon="ai-text-translate" size={16} />}
      data-test="multilingual-override-context-menu"
    >
      {!multilingualOptedIn ? (
        <MenuItem
          key="override"
          onClick={() => setMultilingualOptedIn(true, initialValue)}
          data-test="multilingual-override-button"
        >
          <MenuItemLabel>{formatMessage("override")}</MenuItemLabel>
        </MenuItem>
      ) : (
        <MenuItem
          key="removeOverride"
          onClick={() => setMultilingualOptedIn(false)}
          data-test="multilingual-override-button"
        >
          <MenuItemLabel>{formatMessage("removeOverride")}</MenuItemLabel>
        </MenuItem>
      )}
    </ContextMenu>
  );
};

const StyledIcon = styled(SkiliticsIcon)`
  color: inherit;
`;

const formatStrings = {
  override: {
    en: "Override Base",
    es: "Anular base",
    fr: "Remplacer la base",
    de: "Basis überschreiben",
  },
  removeOverride: {
    en: "Remove Override",
    es: "Eliminar anulación",
    fr: "Supprimer l'annulation",
    de: "Überschreibung entfernen",
  },
};
